import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=8df0df18&scoped=true&"
import script from "./AddressComponent.vue?vue&type=script&lang=js&"
export * from "./AddressComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df0df18",
  null
  
)

export default component.exports